<template>
    <div class="home">
        <search-form />

        <appointments-grid v-if="appointments.length !== 0" />

        <div v-if="appointments.length > 0 && filteredAppointments.length > 5" class="mt-4 text-center">
            <button class="btn btn-primary inline" @click.prevent="toggleShowAllClinics">
                <span v-if="showAllClinics">Fewer clinics</span>
                <span v-else>More clinics</span>
            </button>
        </div>

        <cookie-law theme="ascenti" />
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';

    import CookieLaw from 'vue-cookie-law';

    import AppointmentsGrid from '../components/Appointments/AppointmentsGrid';
    import SearchForm from '../components/Form/SearchForm';
    import {getEarliestAppointment} from '../store/appointments';

    export default {
        name: 'home',

        components: {
            AppointmentsGrid,
            CookieLaw,
            SearchForm
        },

        computed: {
            ...mapState('appointments', [
                'showAllClinics',
                'appointments',
            ]),

            filteredAppointments() {
                return this.$store.getters['appointments/filteredAppointments'];
            },
        },

        mounted() {
            this.$gtm.trackView('Homepage', '/');

            this.showNavigation();

            this.setTheme('light');

            this.showComponent({ name: 'appointments-header', props: { ...this.headerProps() } });

            if (this.appointments.length) {
                this.showFooterAppointmentsMessage();
            } else {
                this.setFooterMessage(null);
            }

            this.listen('appointments.load', [
              this.showFooterAppointmentsMessage,
              this.appointmentsTracking
            ]);

            this.$scrollTo('#app');
        },

        destroyed() {
            this.silence('appointments.load', [
                this.showFooterAppointmentsMessage,
                this.appointmentsTracking
            ]);
        },

        methods: {
            ...mapActions('header', ['showComponent', 'showNavigation', 'setTheme']),

            ...mapActions('footer', ['setFooterMessage']),

            ...mapActions('appointments', ['toggleShowAllClinics']),

            headerProps() {
                return {
                    pageTitle: 'Book physiotherapy',
                    copy: 'Personal consultation with one of Ascenti’s expert physios, in a clinic near you.',
                    items: [
                        {
                            icon: 'medical',
                            text: '30 minute consultation to create a personal treatment plan'
                        }
                    ]
                }
            },

            appointmentsTracking() {
                this.$gtm.trackEvent({
                    event: 'searchresult',
                    slots: this.getTotalSlots(),
                    nearestdistance: this.getDistanceToNearestClinic(),
                    nearesttimeslot: this.getHoursUntilFirstAppointment(),
                });
            },

            getTotalSlots() {
                const clinics = this.filteredAppointments;

                let i, total = 0;

                for (i in clinics) {
                    if (clinics.hasOwnProperty(i)) {
                        total += clinics[i].Appointments.length;
                    }
                }

                return total;
            },

            getDistanceToNearestClinic() {
                const clinics = this.filteredAppointments;

                let i, distance;

                for (i in clinics) {
                    if (clinics.hasOwnProperty(i)) {
                        if (!distance || clinics[i].Distance < distance) {
                            distance = clinics[i].Distance;
                        }
                    }
                }

                return distance;
            },

            getHoursUntilFirstAppointment() {
                const clinics = this.filteredAppointments, now = window.moment();

                let i, earliest1, earliest2, futureOnly = true;

                for (i in clinics) {
                    if (clinics.hasOwnProperty(i)) {
                        if (!clinics[i].Appointments.length) {
                            continue;
                        }

                        if (!earliest1) {
                            earliest1 = getEarliestAppointment(clinics[i], futureOnly);

                            if (earliest1.isBefore(now)) {
                                earliest1 = null;
                            }

                            continue;
                        }

                        earliest2 = getEarliestAppointment(clinics[i], futureOnly);

                        if (earliest2.isBefore(earliest1) && earliest2.isSameOrAfter(now)) {
                            earliest1 = earliest2;
                        }
                    }
                }

                if (!earliest1) {
                    return null;
                }

                return parseInt(window.moment.duration(earliest1.diff(now)).asHours());
            },
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.prevRoute = from
            });

            if (from.name && from.name === 'video-home') {
                location.reload();
            }
        },
    }
</script>
